//import { Component, Inject, OnInit, Renderer2, NgZone, ViewChild, AfterViewInit, ElementRef,Input, Output, EventEmitter } from '@angular/core';
//import { DOCUMENT } from '@angular/common';
//import { NavbarService } from '../../../_services/navbar.service';
//import { ThemeSettingsService } from '../../settings/theme-settings.service';
//import { Subject } from 'rxjs';
//import { takeUntil } from 'rxjs/operators';
//import { PerfectScrollbarConfigInterface, PerfectScrollbarComponent, PerfectScrollbarDirective } from 'ngx-perfect-scrollbar';
//import { MenuSettingsService } from '../../settings/menu-settings.service';
//import { isArray } from 'util';
//import { trigger, state, style, animate, transition } from '@angular/animations';
//import { AppConstants } from 'src/app/_helpers/app.constants';
//import { Router, NavigationEnd, Event } from '@angular/router';
//import { MenuService } from '../../../_services/domainservice/menu.service';
//import { HttpErrorResponse } from '@angular/common/http';
//import { AlertService } from '../../../_services/alert.service';
//import { VerticalComponent } from '../../header/vertical/vertical.component';
//import { Menu } from '../../../model/menu.model';
//import { Guid } from '../../../_helpers/guid';

//@Component({

//  selector: 'app-verticalnav',
//  templateUrl: './verticalnav.component.html',
//  styleUrls: ['./verticalnav.component.css'],
////  animations: [
////    trigger('popOverState', [
////      state('show', style({
////        opacity: '1',
////      })),
////      state('hide', style({
////        opacity: '0',
////        height: '*',
////      })),
////      transition('show => hide', animate('200ms ease-in-out')),
////      transition('hide => show', animate('200ms ease-in-out'))
////    ])
////  ]
//})
////implements OnInit, AfterViewInit
//export class VerticalnavComponent implements OnInit, AfterViewInit  {
////  child: any;
////  insideTm: any;
////  outsideTm: any;
////  loggedInUser: any;
////  selected: any = {};
////  public title;
////  private _themeSettingsConfig: any;
////  public _menuSettingsConfig: any;
////  private _unsubscribeAll: Subject<any>;
////  private _unsubscribeAllMenu: Subject<any>;

////  public config: PerfectScrollbarConfigInterface = { wheelPropagation: false };
////  @ViewChild('main-menu-navigation') mainmenunavigation!: ElementRef;



////  @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
////  @ViewChild(PerfectScrollbarDirective, { static: true }) directiveRef?: PerfectScrollbarDirective;
////  // @ViewChild(VerticalComponent) verticalComponent?: VerticalComponent;
////  // @ViewChild(VerticalnavComponent) verticalnavComponent?: VerticalnavComponent;

////  constructor(
////    @Inject(DOCUMENT) private document: Document,
////    private navbarService: NavbarService,
////    private _themeSettingsService: ThemeSettingsService,
////    private _menuSettingsService: MenuSettingsService,
////    private _renderer: Renderer2,
////    private router: Router,
////    readonly menuService: MenuService,
////    readonly alertService: AlertService,
////  ) {
////    this._unsubscribeAll = new Subject();
////    this._unsubscribeAllMenu = new Subject();
////    this.router.events.subscribe((event: Event) => {

////      if (event instanceof NavigationEnd) {
////        this.resetMainMenu();
////        this.setActiveRouteInNavbar();
////      }
////    });
////    this.menuService.getMenus.subscribe((mm) => {
////      this.custommenu = mm;
////      if (this.custommenu && this.custommenu != undefined && this.custommenu != null && this.custommenu.lenght>0) {
////        let returnUrl = this.custommenu[0].page;// '/dashboard/gym';
////        this.alertService.success("Welcome!");
////        this.router.navigate([returnUrl]);
////      }
////    });
////  }
////  ngOnInit() {

////    // Subscribe to config changes
////    this._themeSettingsService.config
////      .pipe(takeUntil(this._unsubscribeAll))
////      .subscribe((config) => {
////        this._themeSettingsConfig = config;
////        this.refreshView();
////      });
////    this._menuSettingsService.config
////      .pipe(takeUntil(this._unsubscribeAllMenu))
////      .subscribe((config) => {
////        this._menuSettingsConfig = config;
////      });
////    // TODO Patch to reset menu after login
////    this.resetMainMenu();
////    this.setActiveRouteInNavbar();
////    this.getMasterData();

////  }
////  custommenu: any;
////  ngAfterViewInit(): void {

////    const element = this.mainmenunavigation?.nativeElement.childNodes;


////// this.verticalComponent.verticalnavComponent = this.verticalnavComponent;
////  }
////  getMasterData() {

////    //if (JSON.parse(localStorage.getItem('currentProduct')).productUId === '00000010-0000-0000-0000-000000000000') {

////    //  this.menuService.getMenu().subscribe((data): void => {
////    //    this.custommenu = data.sort(function (a, b) {
////    //      return a.displayOrder - b.displayOrder;
////    //    });
////    //  },
////    //    (error: HttpErrorResponse): void => {
////    //      console.log(error);
////    //      this.alertService.error(error.message);
////    //    }
////    //  );
////    //} else {
////    this.menuService.getMenuProduct(JSON.parse(localStorage.getItem('currentProduct')).productUId).subscribe((data): void => {
////      this.custommenu = data.sort(function (a, b) {
////        return a.displayOrder - b.displayOrder;
////      });
////      this.menuService.setmenu(this.custommenu)
////    },
////      (error: HttpErrorResponse): void => {
////        console.log(error);
////        this.alertService.error(error.message);
////      }
////    );
////    //}
////  }

////  select(type, item, $event) {
////    this.selected[type] = (this.selected[type] === item ? null : item);
////    console.log('Item: ', item);
////    $event ? $event.stopPropagation() : null;
////  }
////  isActive(type, item) {
////    return this.selected[type] === item;
////  }

////  resetMainMenu() {
////    const nodes = this.mainmenunavigation?.nativeElement.childNodes;
////    //const nodes = this.document.getElementById('main-menu-navigation').childNodes;
////    for (let i = 0; i < nodes?.length; i++) {
////      this.resetCollapseMenu(nodes[i]);
////    }
////    for (let i = 0; i < this._menuSettingsConfig.vertical_menu.items?.length; i++) {
////      this._menuSettingsConfig.vertical_menu.items[i]['isSelected'] = false;
////      this._menuSettingsConfig.vertical_menu.items[i]['hover'] = false;
////      this._menuSettingsConfig.vertical_menu.items[i]['isOpen'] = false;
////      this.resetSubmenuItems(this._menuSettingsConfig.vertical_menu.items[i]);
////    }
////  }

////  resetCollapseMenu(element) {
////    if (element.classList && element.classList.contains('has-sub') && element.classList.contains('open')) {
////      element.classList.remove('hover');
////      element.classList.remove('menu-collapsed-open');
////    }
////  }

////  resetSubmenuItems(parentItem) {
////    if (parentItem['submenu'] &&
////      parentItem['submenu']['items'] &&
////      parentItem['submenu']['items'].length > 0) {
////      parentItem['isOpen'] = false;
////      for (let j = 0; j < parentItem['submenu']['items'].length; j++) {
////        parentItem['submenu']['items'][j]['isSelected'] = false;
////        this.resetSubmenuItems(parentItem['submenu']['items'][j]);
////      }
////    }
////  }

////  refreshView() {
////    const mainMenuElement = document.getElementsByClassName('main-menu');
////    if (mainMenuElement && mainMenuElement.length > 0) {
////      if (this._themeSettingsConfig.colorTheme === 'semi-light' || this._themeSettingsConfig.colorTheme === 'light') {
////        this._renderer.removeClass(mainMenuElement.item(0), 'menu-dark');
////        this._renderer.addClass(mainMenuElement.item(0), 'menu-light');
////      } else if (this._themeSettingsConfig.colorTheme === 'semi-dark' || this._themeSettingsConfig.colorTheme === 'dark') {
////        this._renderer.addClass(mainMenuElement.item(0), 'menu-dark');
////        this._renderer.removeClass(mainMenuElement.item(0), 'menu-light');
////      }
////      if (this._themeSettingsConfig.layout.pattern === 'static') {
////        this._renderer.removeClass(mainMenuElement.item(0), 'menu-fixed');
////        this._renderer.addClass(mainMenuElement.item(0), 'menu-static');
////      } else if (this._themeSettingsConfig.layout.pattern === 'fixed') {
////        this._renderer.removeClass(mainMenuElement.item(0), 'menu-static');
////        this._renderer.addClass(mainMenuElement.item(0), 'menu-fixed');
////      }
////    }
////  }

////  setActiveRouteInNavbar() {
////    for (let i = 0; i < this._menuSettingsConfig.vertical_menu.items.length; i++) {
////      if (!this._menuSettingsConfig.vertical_menu.items[i].submenu &&
////        this._menuSettingsConfig.vertical_menu.items[i].page === this.router.url) {
////        this._menuSettingsConfig.vertical_menu.items[i]['isSelected'] = true;
////        break;
////      } else if (this._menuSettingsConfig.vertical_menu.items[i].submenu) {
////        // Level 1 menu
////        for (let j = 0; j < this._menuSettingsConfig.vertical_menu.items[i].submenu.items.length; j++) {
////          if (!this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].submenu &&
////            this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].page === this.router.url) {
////            this._menuSettingsConfig.vertical_menu.items[i]['isSelected'] = true;
////            this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j]['isSelected'] = true;
////            this._menuSettingsConfig.vertical_menu.items[i].isOpen = true;
////            break;
////          } else if (this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].submenu) {
////            // Level 2 menu
////            for (let k = 0; k < this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].submenu.items.length; k++) {
////              if (this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].submenu.items[k].page === this.router.url) {
////                this._menuSettingsConfig.vertical_menu.items[i]['isSelected'] = true;
////                this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j]['isSelected'] = true;
////                this._menuSettingsConfig.vertical_menu.items[i].isOpen = true;

////                this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j]['isSelected'] = true;
////                this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].submenu.items[k]['isSelected'] = true;
////                this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].isOpen = true;
////              }
////            }
////          } else if (!this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].submenu) {
////            let a, b;
////            let URL = localStorage.getItem('creatorurl');
////            let SurveyUrl = localStorage.getItem('surveyurl');
////            if (this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].page === '/creator' && this.router.url === URL) {
////              a = j;
////              this._menuSettingsConfig.vertical_menu.items[i]['isSelected'] = true;
////              this._menuSettingsConfig.vertical_menu.items[i].submenu.items[a]['isSelected'] = true;
////              this._menuSettingsConfig.vertical_menu.items[i].isOpen = true;
////              // this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j]['isSelected'] = false;
////            } else if (this._menuSettingsConfig.vertical_menu.items[i].submenu.items[j].page === '/survey' && this.router.url === SurveyUrl) {
////              b = j;
////              this._menuSettingsConfig.vertical_menu.items[i]['isSelected'] = true;
////              this._menuSettingsConfig.vertical_menu.items[i].submenu.items[b]['isSelected'] = true;
////              this._menuSettingsConfig.vertical_menu.items[i].isOpen = true;
////              if (this._menuSettingsConfig.vertical_menu.items[i].submenu.items[a]) {
////                this._menuSettingsConfig.vertical_menu.items[i].submenu.items[a]['isSelected'] = false;
////              }
////            }
////          }
////        }
////      }
////    }
////  }

////  resetOpenMenu() {
////    for (let i = 0; i < this._menuSettingsConfig.vertical_menu.items.length; i++) {
////      const menu = this._menuSettingsConfig.vertical_menu.items[i];
////      if (!menu.submenu) {
////        menu['isOpen'] = false;
////        menu['isActive'] = false;
////        menu['hover'] = false;
////      } else if (menu.submenu) {
////        for (let j = 0; j < menu.submenu.items.length; j++) {
////          menu['isOpen'] = false;
////          menu['isActive'] = false;
////          menu['hover'] = false;
////          menu.submenu.items[j]['isOpen'] = false;
////        }
////      }
////    }
////  }

////  setOpenInNavbar(value) {
////    for (let i = 0; i < this._menuSettingsConfig.vertical_menu.items.length; i++) {
////      const menu = this._menuSettingsConfig.vertical_menu.items[i];
////      if (!menu.submenu &&
////        menu.page === this.router.url) {
////        menu['isOpen'] = value;
////        menu['isActive'] = value;
////      } else if (menu.submenu) {
////        for (let j = 0; j < menu.submenu.items.length; j++) {
////          if (menu.submenu.items[j].page === this.router.url) {
////            menu['isOpen'] = value;
////            menu['isActive'] = value;
////            menu.submenu.items[j]['isOpen'] = value;
////            menu.submenu.items[j]['isActive'] = value;
////            break;
////          }
////        }
////      }
////    }
////  }

////  callFunction(event, child, isSubmenuOfSubmenu) {
////    const methodName = event.methodName;
////    if (this[methodName]) {
////      // method exists on the component
////      const param = event.methodParam;
////      if (!isArray(param)) {
////        this[methodName](param); // call it
////      } else {
////        this[methodName](param[0], param[1]); // call it
////      }
////    }
////    this.resetOtherActiveMenu(child, isSubmenuOfSubmenu);
////    child['isSelected'] = true;
////  }

////  setTheme(theme) {
////    this._themeSettingsService.config = {
////      colorTheme: theme, // semi-light, semi-dark
////    };
////  }

////  setLayout(layout) {
////    this._themeSettingsService.config = {
////      layout: {
////        pattern: layout
////      }
////    };
////  }

////  fixComponent(component, value) {
////    if (component === 'header') {
////      this._themeSettingsService.config = {
////        header: value
////      };
////    } else if (component === 'footer') {
////      this._themeSettingsService.config = {
////        footer: value
////      };
////    } else {
////      this._themeSettingsService.config = {
////        header: value,
////        footer: value
////      };
////    }
////  }

////  /**
////   * Use for fixed left aside menu, to show menu on mouseenter event.
////   * @param e Event
////   */
////  mouseEnter(e) {
////    if (this.navbarService.isFixedMenu()) {
////      return;
////    }
////    this.navbarService.setMouseInRegion(true);
////    const navBar = this.document.getElementById('navbar-header');
////    const mainMenu = this.document.getElementById('main-menu');

////    // check if the left aside menu is fixed
////    if (!navBar.classList.contains('expanded')) {
////      this._renderer.addClass(navBar, 'expanded');
////      this._renderer.addClass(mainMenu, 'expanded');
////      this.resetOpenMenu();
////      this.setOpenInNavbar(true);
////    }
////  }

////  /**
////   * Use for fixed left aside menu, to show menu on mouseenter event.
////   * @param e Event
////   */
////  mouseLeave(event) {
////    if (this.navbarService.isFixedMenu()) {
////      return;
////    }
////    const _self = this;
////    const navBar = this.document.getElementById('navbar-header');
////    const mainMenu = this.document.getElementById('main-menu');
////    if (navBar && navBar.classList.contains('expanded')) {
////      this.insideTm = setTimeout(() => {
////        if (!_self.navbarService.isMouseInRegion()) {
////          this._renderer.removeClass(navBar, 'expanded');
////          this._renderer.removeClass(mainMenu, 'expanded');
////          this.resetOpenMenu();
////          this.setOpenInNavbar(false);
////        }
////      }, 100);
////    }
////    this.navbarService.setMouseInRegion(false);
////  }

////  //resetOtherActiveMenu(selectedChild, isSubmenuOfSubmenu) {
////  //  for (let i = 0; i < this._menuSettingsConfig.vertical_menu.items.length; i++) {
////  //    this._menuSettingsConfig.vertical_menu.items[i]['isSelected'] = false;
////  //    this._menuSettingsConfig.vertical_menu.items[i]['hover'] = false;
////  //    this.handleSubmenuItems(this._menuSettingsConfig.vertical_menu.items[i], selectedChild, isSubmenuOfSubmenu);
////  //  }
////  //}

////  resetOtherActiveMenu(selectedChild, isSubmenuOfSubmenu) {
////    for (let i = 0; i < this.custommenu.length; i++) {
////      this.custommenu[i]['isSelected'] = false;
////      this.custommenu[i]['hover'] = false;
////      this.handleSubmenuItems(this.custommenu[i], selectedChild, isSubmenuOfSubmenu);
////    }
////  }

////  //handleSubmenuItems(parentItem, selectedChild, isSubmenuOfSubmenu) {
////  //  if (selectedChild['title'] === 'Horizontal') {
////  //    localStorage.setItem('currentLayoutStyle', AppConstants.LAYOUT_STYLE_HORIZONTAL);
////  //    window.location.reload();
////  //  } else if (selectedChild['title'] === 'Vertical') {
////  //    localStorage.setItem('currentLayoutStyle', AppConstants.LAYOUT_STYLE_VERTICAL);
////  //    window.location.reload();
////  //  } else if (parentItem['submenu'] &&
////  //    parentItem['submenu']['items'] &&
////  //    parentItem['submenu']['items'].length > 0) {
////  //    if (parentItem.title !== selectedChild.title && parentItem['isOpen'] === true && !isSubmenuOfSubmenu &&
////  //      this._themeSettingsConfig.navigation === AppConstants.NAVIGATION_TYPE_COLLAPSIBLE) {
////  //      parentItem['isOpen'] = false;
////  //    }
////  //    for (let j = 0; j < parentItem['submenu']['items'].length; j++) {
////  //      if (selectedChild.page !== 'null') {
////  //        parentItem['submenu']['items'][j]['isSelected'] = false;
////  //      }
////  //      this.handleSubmenuItems(parentItem['submenu']['items'][j], selectedChild, isSubmenuOfSubmenu);
////  //    }
////  //  } else if (parentItem.title !== selectedChild.title && !selectedChild.submenu
////  //    && this._themeSettingsConfig.navigation === AppConstants.NAVIGATION_TYPE_COLLAPSIBLE
////  //    && parentItem['isOpen'] === true) {
////  //    parentItem['isOpen'] = false;
////  //  }
////  //}

////  handleSubmenuItems(parentItem, selectedChild, isSubmenuOfSubmenu) {
////    if (selectedChild['title'] === 'Horizontal') {
////      localStorage.setItem('currentLayoutStyle', AppConstants.LAYOUT_STYLE_HORIZONTAL);
////      window.location.reload();
////    } else if (selectedChild['title'] === 'Vertical') {
////      localStorage.setItem('currentLayoutStyle', AppConstants.LAYOUT_STYLE_VERTICAL);
////      window.location.reload();
////    } else if (parentItem['submenu'] &&
////      parentItem['submenu']['items'] &&
////      parentItem['submenu']['items'].length > 0) {
////      if (parentItem.title !== selectedChild.title && parentItem['isOpen'] === true && !isSubmenuOfSubmenu &&
////        this._themeSettingsConfig.navigation === AppConstants.NAVIGATION_TYPE_COLLAPSIBLE) {
////        parentItem['isOpen'] = false;
////      }
////      for (let j = 0; j < parentItem['submenu']['items'].length; j++) {
////        if (selectedChild.page !== 'null') {
////          parentItem['submenu']['items'][j]['isSelected'] = false;
////        }
////        this.handleSubmenuItems(parentItem['submenu']['items'][j], selectedChild, isSubmenuOfSubmenu);
////      }
////    } else if (parentItem.title !== selectedChild.title && !selectedChild.submenu
////      && this._themeSettingsConfig.navigation === AppConstants.NAVIGATION_TYPE_COLLAPSIBLE
////      && parentItem['isOpen'] === true) {
////      parentItem['isOpen'] = false;
////    }
////  }

////  toggleMenu(event, child, isSubmenuOfSubmenu) {
////    const toggle = document.getElementById('sidenav-overlay');
////    this.resetOtherActiveMenu(child, isSubmenuOfSubmenu);
////    this.loggedInUser = JSON.parse(localStorage.getItem('currentUser'));
////    if (child['isSelected'] === true) {
////      child['isSelected'] = false;
////    } else {
////      child['isSelected'] = true;
////    }

////    if (child['hover'] === true) {
////      child['hover'] = false;
////    } else {
////      child['hover'] = true;
////    }

////    if (child['isOpen'] === true) {
////      child['isOpen'] = false;
////    } else {
////      child['isOpen'] = true;
////    }

////    if (this.router.url !== '') {
////      this._renderer.addClass(toggle, 'd-none');
////      this._renderer.removeClass(toggle, 'd-block');
////    }

////    if (child.page === '/chats' && this.loggedInUser.email === 'john@pixinvent.com') {
////      this.router.navigate(['/chats/static-chat']);
////    } else if (child.page === '/chats' && this.loggedInUser.email !== 'john@pixinvent.com') {
////      this.router.navigate(['/chats']);
////    }

//  //  }

//  @Input() isOpen = false;
//  public _menuSettingsConfig: any;
//  //@Output() routeChanged = new EventEmitter<string>();
//  @ViewChild('main-menu-navigation') mainmenunavigation!: ElementRef;

//  //activeRoute = 'dashboard';
//  custommenu: any;
//  private _themeSettingsConfig: any;
//  private _unsubscribeAll: Subject<any>;
//  private _unsubscribeAllMenu: Subject<any>;
//  productuid: Guid;

//  constructor(private router: Router,
//    private menuService: MenuService,
//    private alertService: AlertService,
//    private _themeSettingsService: ThemeSettingsService,
//    private _menuSettingsService: MenuSettingsService) {
//    this._unsubscribeAll = new Subject();
//    this._unsubscribeAllMenu = new Subject();

//          }


//  ngOnInit() {
//    this._themeSettingsService.config
//          .pipe(takeUntil(this._unsubscribeAll))
//          .subscribe((config) => {
//            this._themeSettingsConfig = config;
//            //this.refreshView();
//          });
//        this._menuSettingsService.config
//          .pipe(takeUntil(this._unsubscribeAllMenu))
//          .subscribe((config) => {
//            this._menuSettingsConfig = config;
//          });
//    // TODO Patch to reset menu after login
//    //this.setActiveRouteInNavbar();
//       // this.resetMainMenu();
//    this.getmasterdata();
//  }

//  ngAfterViewInit(): void {

//        const element = this.mainmenunavigation?.nativeElement.childNodes;
//  }

//  getmasterdata() {
//    this.productuid = JSON.parse(localStorage.getItem('currentProduct')).productUId;
//    //console.log(this.productuid);
//    this.menuService.getMenuProduct(JSON.parse(localStorage.getItem('currentProduct')).productUId).subscribe((data): void => {
//          this.custommenu = data.sort(function (a, b) {
//            return a.displayOrder - b.displayOrder;
//          });
//      this.menuService.setmenu(this.custommenu)
//      console.log(this.custommenu);
//        },
//          (error: HttpErrorResponse): void => {
//            console.log(error);
//            this.alertService.error(error.message);
//          }
//        );
//  }


//    resetCollapseMenu(element) {
//      if (element.classList && element.classList.contains('has-sub') && element.classList.contains('open')) {
//        element.classList.remove('hover');
//        element.classList.remove('menu-collapsed-open');
//      }
//    }

//    resetSubmenuItems(parentItem) {
//      if (parentItem['submenu'] &&
//        parentItem['submenu']['items'] &&
//        parentItem['submenu']['items'].length > 0) {
//        parentItem['isOpen'] = false;
//        for (let j = 0; j < parentItem['submenu']['items'].length; j++) {
//          parentItem['submenu']['items'][j]['isSelected'] = false;
//          this.resetSubmenuItems(parentItem['submenu']['items'][j]);
//        }
//      }
//  }
//}


//import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
//import { trigger, state, style, animate, transition } from '@angular/animations';
//import { HttpErrorResponse } from '@angular/common/http';
//import { Router } from '@angular/router';
//import { Subject } from 'rxjs';
//import { takeUntil } from 'rxjs/operators';

//import { AlertService } from '../../../_services/alert.service';
//import { MenuService } from '../../../_services/domainservice/menu.service';
//import { MenuSettingsService } from '../../settings/menu-settings.service';
//import { ThemeSettingsService } from '../../settings/theme-settings.service';
//import { Guid } from '../../../_helpers/guid';
//import { Menu } from '../../../model/menu.model';

//interface VerticalMenuBadge {
//  type: string;
//  value: string;
//}

//interface VerticalMenuItem {
//  menuUId?: string;
//  title?: string;
//  icon?: string;
//  page?: string;
//  section?: string;
//  badge?: VerticalMenuBadge;
//  submenu?: { items: VerticalMenuItem[] };
//  isOpen?: boolean;
//  isSelected?: boolean;
//  hover?: boolean;
//  excludeInVertical?: boolean;
//  isExternalLink?: boolean;
//  issupportExternalLink?: boolean;
//  isStarterkitExternalLink?: boolean;
//}

//@Component({
//  selector: 'app-verticalnav',
//  templateUrl: './verticalnav.component.html',
//  styleUrls: ['./verticalnav.component.css'],
//  animations: [
//    trigger('popOverState', [
//      state('true', style({ display: 'block', opacity: 1, height: '*' })),
//      state('false', style({ display: 'none', opacity: 0, height: 0 })),
//      transition('false <=> true', animate('180ms ease-in-out')),
//    ]),
//  ],
//})
//export class VerticalnavComponent implements OnInit, AfterViewInit, OnDestroy {
//  @Input() isOpen = false;
//  @Output() routeChanged = new EventEmitter<string>();
//  @ViewChild('mainMenuNavigation') mainMenuNavigation!: ElementRef<HTMLElement>;

//  custommenu: VerticalMenuItem[] = [];
//  activeRoute = '';
//  productuid?: Guid | string;

//  public _menuSettingsConfig: any;
//  private _themeSettingsConfig: any;
//  private readonly _unsubscribeAll = new Subject<void>();
//  private readonly _unsubscribeAllMenu = new Subject<void>();

//  constructor(
//    public router: Router,
//    private readonly menuService: MenuService,
//    private readonly alertService: AlertService,
//    private readonly _themeSettingsService: ThemeSettingsService,
//    private readonly _menuSettingsService: MenuSettingsService
//  ) { }

//  ngOnInit(): void {
//    this.activeRoute = this.router.url;

//    this._themeSettingsService.config
//      .pipe(takeUntil(this._unsubscribeAll))
//      .subscribe((config) => {
//        this._themeSettingsConfig = config;
//      });

//    this._menuSettingsService.config
//      .pipe(takeUntil(this._unsubscribeAllMenu))
//      .subscribe((config) => {
//        this._menuSettingsConfig = config;
//      });

//    //this.menuService.getMenus
//    //  .pipe(takeUntil(this._unsubscribeAll))
//    //  .subscribe((menu) => {
//    //    if (menu?.length) {
//    //      this.custommenu = this.buildVerticalMenu(menu);
//    //      this.markActiveRoute(this.custommenu);
//    //    }
//    //  });

//    this.getmasterdata();
//  }

//  ngAfterViewInit(): void {
//    this.markActiveRoute(this.custommenu);
//  }

//  ngOnDestroy(): void {
//    this._unsubscribeAll.next();
//    this._unsubscribeAll.complete();
//    this._unsubscribeAllMenu.next();
//    this._unsubscribeAllMenu.complete();
//  }

//  getmasterdata(): void {
//    const currentProduct = this.safeJsonParse(localStorage.getItem('currentProduct'));
//    const productUId = currentProduct?.productUId || currentProduct?.ProductUId;
//    const userGroupUgid = this.getCurrentUserGroupUgid();

//    if (!productUId) {
//      this.alertService.error('ProductUId is missing. Menu cannot be loaded.');
//      return;
//    }

//    this.productuid = productUId;
//    this.menuService.getMenuProduct(productUId, userGroupUgid).subscribe(
//      (data): void => {
//        const menu = this.sortMenu(data);
//        this.menuService.setmenu(menu);
//        this.custommenu = this.buildVerticalMenu(menu);
//        this.markActiveRoute(this.custommenu);
//      },
//      (error: HttpErrorResponse): void => {
//        console.log(error);
//        this.alertService.error(error.message);
//      }
//    );
//  }

//  toggleMenu(event: Event, item: VerticalMenuItem, isSubmenu = false): void {
//    if (!item) {
//      return;
//    }

//    if (item.submenu?.items?.length) {
//      event.preventDefault();
//      item.isOpen = !item.isOpen;
//      item.isSelected = true;
//      return;
//    }

//    this.clearSelection(this.custommenu);
//    item.isSelected = true;
//    this.activeRoute = item.page || this.router.url;
//    this.routeChanged.emit(this.activeRoute);

//    if (isSubmenu) {
//      this.openParentForSelected(this.custommenu, item);
//    }
//  }

//  callFunction(functionName: string, item: VerticalMenuItem): void {
//    if (!functionName) {
//      return;
//    }

//    const possibleFunction = (this as unknown as Record<string, unknown>)[functionName];
//    if (typeof possibleFunction === 'function') {
//      possibleFunction.call(this, item);
//    }
//  }

//  trackByMenu(_: number, item: VerticalMenuItem): string {
//    return item.menuUId || `${item.section || ''}-${item.title || ''}-${item.page || ''}`;
//  }

//  resetCollapseMenu(element: HTMLElement): void {
//    if (element.classList && element.classList.contains('has-sub') && element.classList.contains('open')) {
//      element.classList.remove('hover');
//      element.classList.remove('menu-collapsed-open');
//    }
//  }

//  resetSubmenuItems(parentItem: VerticalMenuItem): void {
//    if (parentItem.submenu?.items?.length) {
//      parentItem.isOpen = false;
//      parentItem.submenu.items.forEach((item) => {
//        item.isSelected = false;
//        this.resetSubmenuItems(item);
//      });
//    }
//  }

//  private buildVerticalMenu(menu: Menu[]): VerticalMenuItem[] {
//    const sortedMenu = this.sortMenu(menu);
//    const result: VerticalMenuItem[] = [];
//    let currentSection = '';

//    sortedMenu.forEach((menuItem) => {
//      const section = this.readMenuValue(menuItem, 'section', 'Section');
//      if (section && section !== currentSection) {
//        currentSection = section;
//        result.push({
//          section,
//          icon: this.readMenuValue(menuItem, 'icon', 'Icon') || 'la-circle',
//        });
//      }

//      const title = this.readMenuValue(menuItem, 'title', 'Title');
//      if (!title) {
//        return;
//      }

//      result.push({
//        menuUId: this.readMenuValue(menuItem, 'menuUId', 'MenuUId'),
//        title,
//        icon: this.readMenuValue(menuItem, 'icon', 'Icon') || 'la-circle',
//        page: this.readMenuValue(menuItem, 'page', 'Page') || 'null',
//        badge: this.toBadge(menuItem),
//        excludeInVertical: this.readBooleanValue(menuItem, 'excludeInVertical', 'ExcludeInVertical'),
//        isExternalLink: this.readBooleanValue(menuItem, 'isExternalLink', 'IsExternalLink'),
//        issupportExternalLink: this.readBooleanValue(menuItem, 'issupportExternalLink', 'IsSupportExternalLink'),
//        isStarterkitExternalLink: this.readBooleanValue(menuItem, 'isStarterkitExternalLink', 'IsStarterkitExternalLink'),
//        isOpen: false,
//        isSelected: false,
//      });
//    });

//    return result;
//  }

//  private sortMenu(menu: Menu[]): Menu[] {
//    return [...(menu || [])].sort((a, b) => {
//      const left = Number(this.readMenuValue(a, 'displayOrder', 'DisplayOrder')) || 0;
//      const right = Number(this.readMenuValue(b, 'displayOrder', 'DisplayOrder')) || 0;
//      return left - right;
//    });
//  }

//  private markActiveRoute(items: VerticalMenuItem[]): boolean {
//    let found = false;
//    items.forEach((item) => {
//      const isCurrent = Boolean(item.page && item.page !== 'null' && this.router.url.includes(item.page));
//      const childSelected = item.submenu?.items ? this.markActiveRoute(item.submenu.items) : false;
//      item.isSelected = isCurrent || childSelected;
//      item.isOpen = childSelected || item.isOpen;
//      found = found || item.isSelected;
//    });

//    return found;
//  }

//  private clearSelection(items: VerticalMenuItem[]): void {
//    items.forEach((item) => {
//      item.isSelected = false;
//      if (item.submenu?.items?.length) {
//        this.clearSelection(item.submenu.items);
//      }
//    });
//  }

//  private openParentForSelected(items: VerticalMenuItem[], selectedItem: VerticalMenuItem): boolean {
//    for (const item of items) {
//      if (item === selectedItem) {
//        return true;
//      }

//      if (item.submenu?.items?.length && this.openParentForSelected(item.submenu.items, selectedItem)) {
//        item.isOpen = true;
//        item.isSelected = true;
//        return true;
//      }
//    }

//    return false;
//  }

//  private toBadge(menuItem: Menu): VerticalMenuBadge | undefined {
//    const value = this.readMenuValue(menuItem, 'badgeValue', 'BadgeValue');
//    if (!value) {
//      return undefined;
//    }

//    return {
//      value,
//      type: this.readMenuValue(menuItem, 'badgeType', 'BadgeType') || 'badge-info',
//    };
//  }

//  private getCurrentUserGroupUgid(): string {
//    return (
//      localStorage.getItem('CurrentRoleBasedlogedin') ||
//      localStorage.getItem('roleBasedLogedin') ||
//      localStorage.getItem('currentRoleBasedLogedin') ||
//      ''
//    ).trim();
//  }

//  private safeJsonParse(value: string | null): any {
//    if (!value) {
//      return null;
//    }

//    try {
//      return JSON.parse(value);
//    } catch {
//      return null;
//    }
//  }

//  private readMenuValue(menuItem: Menu, camelKey: string, pascalKey: string): string {
//    const record = menuItem as unknown as Record<string, unknown>;
//    const value = record[camelKey] ?? record[pascalKey];
//    return value === undefined || value === null ? '' : String(value).trim();
//  }

//  private readBooleanValue(menuItem: Menu, camelKey: string, pascalKey: string): boolean {
//    const record = menuItem as unknown as Record<string, unknown>;
//    const value = record[camelKey] ?? record[pascalKey];
//    if (typeof value === 'boolean') {
//      return value;
//    }
//    if (typeof value === 'number') {
//      return value === 1;
//    }
//    if (typeof value === 'string') {
//      return ['1', 'true', 'yes', 'y'].includes(value.toLowerCase());
//    }

//    return false;
//  }
//}



//import { HttpErrorResponse } from '@angular/common/http';
//import {
//  ChangeDetectionStrategy,
//  ChangeDetectorRef,
//  Component,
//  EventEmitter,
//  HostBinding,
//  Input,
//  OnDestroy,
//  OnInit,
//  Output,
//} from '@angular/core';
//import { NavigationEnd, Router } from '@angular/router';
//import { Subscription } from 'rxjs';
//import { filter } from 'rxjs/operators';

//import { AlertService } from '../../../_services/alert.service';
//import {
//  DashboardMenuItem,
//  DashboardMenuSection,
//  MenuService,
//} from '../../../_services/domainservice/menu.service';

///**
// * Replacement for the old verticalnav. Same component selector, same @Input
// * and @Output names — so wherever <app-verticalnav> is already used in your
// * parent layout, this renders the new design without any other code changes.
// *
// * Routes are resolved relative to {@link basePath}; pass `[basePath]="''"` if
// * your menu rows already store fully-qualified URLs.
// */
//@Component({
//  selector: 'app-verticalnav',
//  templateUrl: './verticalnav.component.html',
//  styleUrls: ['./verticalnav.component.css'],
//  changeDetection: ChangeDetectionStrategy.OnPush,
//})
//export class VerticalnavComponent implements OnInit, OnDestroy {

//  // ─── Preserved API ─────────────────────────────────────────
//  @Input() isOpen = false;
//  @Output() routeChanged = new EventEmitter<string>();

//  // ─── New inputs (have safe defaults) ───────────────────────
//  @Input() companyName = 'Om Hotel Sarvana Bhavan';
//  @Input() suiteName = 'Billing Suite';
//  @Input() companyLogoUrl = '';
//  /**
//   * Prepended to any relative route in the menu rows. If your DB stores
//   * `manager`, `accountcreationforbilling`, etc., set this to whatever
//   * Angular route currently mounts those forms. Pass `''` if your DB
//   * rows already contain the full URL.
//   */
//  @Input() basePath = '';
//  @Input() menuRefreshIntervalMs = 30000;

//  @HostBinding('class.sidebar-open')
//  get hostOpen(): boolean { return this.isOpen; }

//  // ─── State ──────────────────────────────────────────────────
//  navSections: DashboardMenuSection[] = [];
//  menuLoading = false;
//  menuError = false;
//  activeMenuId = '';
//  activeRoute = '';

//  // ─── Fallback menu (used until / unless the API returns rows) ──
//  readonly fallbackNavSections: DashboardMenuSection[] = [
//    {
//      label: 'Main', sortOrder: 10,
//      items: [
//        { id: 'dashboard', iconKey: 'dashboard', label: 'Dashboard', route: 'dashboard/billing', sortOrder: 1, section: 'Main' },
//      ],
//    },
//    {
//      label: 'Account & Management', sortOrder: 20,
//      items: [
//        { id: 'account-creation', iconKey: 'user', label: 'Account Creation', route: 'Billing/accountcreationforbilling', sortOrder: 1, section: 'Account & Management' },
//      ],
//    },
//    {
//      label: 'Registration', sortOrder: 30,
//      items: [
//        { id: 'manager', iconKey: 'user', label: 'Manager', route: 'manager', sortOrder: 1, section: 'Registration' },
//        { id: 'supervisor', iconKey: 'eye', label: 'Supervisor', route: 'supervisor', sortOrder: 2, section: 'Registration' },
//        { id: 'supplier', iconKey: 'truck', label: 'Supplier', route: 'supplier', sortOrder: 3, section: 'Registration' },
//      ],
//    },
//    {
//      label: 'Customer Management', sortOrder: 40,
//      items: [
//        { id: 'customer', iconKey: 'users', label: 'Customer', route: 'customer', sortOrder: 1, section: 'Customer Management' },
//      ],
//    },
//    {
//      label: 'Attendance', sortOrder: 90,
//      items: [
//        { id: 'manager-attendance', iconKey: 'report', label: 'Manager Report', route: 'managerattendance', sortOrder: 1, section: 'Attendance' },
//        { id: 'supervisor-attendance', iconKey: 'report', label: 'Supervisor Report', route: 'supervisorattendance', sortOrder: 2, section: 'Attendance' },
//        { id: 'supplier-attendance', iconKey: 'report', label: 'Supplier Report', route: 'supplierattendance', sortOrder: 3, section: 'Attendance' },
//        { id: 'attendance-report', iconKey: 'report', label: 'Attendance Report', route: 'attendancereport', sortOrder: 4, section: 'Attendance', badge: '3' },
//      ],
//    },
//  ];

//  // ─── Internals ──────────────────────────────────────────────
//  private menuSubscription?: Subscription;
//  private routerSubscription?: Subscription;
//  private menuRefreshTimer?: number;

//  constructor(
//    private readonly cd: ChangeDetectorRef,
//    private readonly router: Router,
//    private readonly menuService: MenuService,
//    private readonly alertService: AlertService,
//  ) {
//    this.navSections = this.fallbackNavSections;
//  }

//  ngOnInit(): void {
//    this.activeRoute = this.router.url;
//    this.syncActiveFromUrl(this.router.url);
//    this.loadMenus();
//    this.startMenuRefresh();

//    this.routerSubscription = this.router.events
//      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
//      .subscribe((e) => {
//        this.activeRoute = e.urlAfterRedirects;
//        this.syncActiveFromUrl(e.urlAfterRedirects);
//        this.cd.markForCheck();
//      });
//  }

//  ngOnDestroy(): void {
//    if (typeof window !== 'undefined' && this.menuRefreshTimer) {
//      window.clearInterval(this.menuRefreshTimer);
//    }
//    this.menuSubscription?.unsubscribe();
//    this.routerSubscription?.unsubscribe();
//  }

//  // ═════════════════════════════════════════════════════════════
//  // Menu loading
//  // ═════════════════════════════════════════════════════════════
//  loadMenus(): void {
//    this.menuLoading = true;
//    this.menuError = false;
//    this.cd.markForCheck();

//    const currentProduct = this.safeJsonParse(localStorage.getItem('currentProduct'));
//    const productUId = currentProduct?.productUId || currentProduct?.ProductUId;
//    const ugid =
//      localStorage.getItem('CurrentRoleBasedlogedin') ||
//      localStorage.getItem('roleBasedLogedin') ||
//      localStorage.getItem('currentRoleBasedLogedin') ||
//      '';

//    if (!productUId) {
//      console.warn('[verticalnav] productUId missing — using fallback menu.');
//      this.applyMenu(this.fallbackNavSections, true);
//      return;
//    }

//    this.menuSubscription?.unsubscribe();
//    this.menuSubscription = this.menuService
//      .getDashboardMenusProduct(productUId, ugid)
//      .subscribe({
//        next: (sections) => {
//          const next = sections && sections.length ? sections : this.fallbackNavSections;
//          this.applyMenu(next, false);
//        },
//        error: (err: HttpErrorResponse) => {
//          console.error('[verticalnav] menu load failed:', err);
//          this.applyMenu(this.fallbackNavSections, true);
//        },
//      });
//  }

//  refreshMenu(): void { this.loadMenus(); }

//  private applyMenu(sections: DashboardMenuSection[], errored: boolean): void {
//    this.navSections = sections;
//    this.menuLoading = false;
//    this.menuError = errored;
//    this.syncActiveFromUrl(this.activeRoute);
//    this.cd.markForCheck();
//  }

//  private startMenuRefresh(): void {
//    if (typeof window === 'undefined' || this.menuRefreshIntervalMs <= 0) return;
//    this.menuRefreshTimer = window.setInterval(() => this.loadMenus(), this.menuRefreshIntervalMs);
//  }

//  // ═════════════════════════════════════════════════════════════
//  // Navigation
//  // ═════════════════════════════════════════════════════════════
//  onNavItem(item: DashboardMenuItem, event?: MouseEvent): void {
//    event?.preventDefault();
//    if (!item.route || item.route === 'null') return;

//    this.activeMenuId = item.id;
//    this.cd.markForCheck();

//    const target = this.resolveTarget(item.route);
//    this.routeChanged.emit(target);   // preserve original output contract

//    this.router.navigateByUrl(target).catch((err) => {
//      console.warn(`[verticalnav] navigation to "${target}" failed:`, err);
//    });
//  }

//  private resolveTarget(route: string): string {
//    if (!route) return '';
//    if (route.startsWith('/')) return route;
//    if (!this.basePath) return '/' + route;
//    const prefix = this.basePath.startsWith('/') ? this.basePath : '/' + this.basePath;
//    return `${prefix}/${route}`.replace(/\/{2,}/g, '/');
//  }

//  private syncActiveFromUrl(url: string): void {
//    const matchAgainst = (route: string) => {
//      if (!route) return false;
//      const target = this.resolveTarget(route);
//      return url === target || url.startsWith(target + '/') || url.startsWith(target + '?');
//    };
//    const found = this.navSections
//      .flatMap((s) => s.items)
//      .find((i) => matchAgainst(i.route || ''));
//    if (found) this.activeMenuId = found.id;
//  }

//  // ═════════════════════════════════════════════════════════════
//  // Icon & track-by helpers
//  // ═════════════════════════════════════════════════════════════
//  emojiFor(iconKey: string | undefined | null): string {
//    switch ((iconKey || '').toLowerCase()) {
//      case 'dashboard': return '⊞';
//      case 'user': return '👤';
//      case 'eye': return '👁️';
//      case 'truck': return '🚚';
//      case 'users': return '🧑‍🤝‍🧑';
//      case 'report': return '📋';
//      case 'order': return '🛒';
//      case 'home': return '🏠';
//      default: return '📌';
//    }
//  }

//  isNavItemActive(item: DashboardMenuItem): boolean {
//    if (item.id === this.activeMenuId) return true;
//    if (!item.route) return false;
//    const target = this.resolveTarget(item.route);
//    return this.activeRoute === target || this.activeRoute.startsWith(target + '/');
//  }

//  trackByNavSection(_: number, s: DashboardMenuSection): string { return s.label; }
//  trackByNavItem(_: number, i: DashboardMenuItem): string { return i.id; }

//  private safeJsonParse(value: string | null): any {
//    if (!value) return null;
//    try { return JSON.parse(value); } catch { return null; }
//  }
//}





// import { HttpErrorResponse, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
// import {
//   ChangeDetectionStrategy,
//   ChangeDetectorRef,
//   Component,
//   EventEmitter,
//   HostBinding,
//   Input,
//   OnDestroy,
//   OnInit,
//   Output, HostListener, Injectable
// } from '@angular/core';
// import { NavigationEnd, Router } from '@angular/router';
// import { Observable, Subject, Subscription, throwError } from 'rxjs';
// import { catchError, filter, takeUntil } from 'rxjs/operators';

// import { AlertService } from '../../../_services/alert.service';
// import {
//   DashboardMenuItem,
//   DashboardMenuSection,
//   MenuService,
// } from '../../../_services/domainservice/menu.service';
// import { ChromeService } from '../../../_services/chrome.service'
// import { CoreGymService } from '../../../_services/core.gym.service.service';
// @Component({
//   selector: 'app-verticalnav',
//   templateUrl: './verticalnav.component.html',
//   styleUrls: ['./verticalnav.component.css'],
//   changeDetection: ChangeDetectionStrategy.OnPush,
// })
// export class VerticalnavComponent implements OnInit, OnDestroy {

//   // ─── Preserved API ─────────────────────────────────────────
//   @Input() isOpen = false;
//   private readonly _unsubscribeAll = new Subject<void>();

//   @Output() routeChanged = new EventEmitter<string>();

//   // ─── New inputs (safe defaults) ────────────────────────────
//   //const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
//   //@Input() company = JSON.parse(localStorage.getItem('currentUser') || '{}').companyName;
//   //@Input() suiteName = 'Billing Suite';
//   //@Input() logo = JSON.parse(localStorage.getItem('currentUser') || '{}').logo;
//   //@Input() companyLogoUrl = this.logo != null && this.logo != '' ? this.coreGymService.BaseUrl + this.logo : 'assets/custom/images/abg/abglogoicon512.ico';
//   @Input() basePath = '';
//   @Input() menuRefreshIntervalMs = 30000;

//   @HostBinding('class.sidebar-open')
//   get hostOpen(): boolean { return this.isOpen; }

//   // ─── State ──────────────────────────────────────────────────
//   navSections: DashboardMenuSection[] = [];
//   menuLoading = false;
//   menuError = false;
//   activeMenuId = '';
//   activeRoute = '';
//   currentUser: any;
//   company: string;
//   logo: string;
//   companyLogoUrl: string;
//   readonly fallbackNavSections: DashboardMenuSection[] = [
//     {
//       label: 'Main', sortOrder: 10,
//       items: [
//         { id: 'dashboard', iconKey: 'dashboard', label: 'Dashboard', route: 'dashboard/billing', sortOrder: 1, section: 'Main' },
//       ],
//     },
//     {
//       label: 'Account & Management', sortOrder: 20,
//       items: [
//         { id: 'account-creation', iconKey: 'user', label: 'Account Creation', route: 'Billing/accountcreationforbilling', sortOrder: 1, section: 'Account & Management' },
//       ],
//     },
//     {
//       label: 'Registration', sortOrder: 30,
//       items: [
//         { id: 'manager', iconKey: 'user', label: 'Manager', route: 'manager', sortOrder: 1, section: 'Registration' },
//         { id: 'supervisor', iconKey: 'eye', label: 'Supervisor', route: 'supervisor', sortOrder: 2, section: 'Registration' },
//         { id: 'supplier', iconKey: 'truck', label: 'Supplier', route: 'supplier', sortOrder: 3, section: 'Registration' },
//       ],
//     },
//     {
//       label: 'Customer Management', sortOrder: 40,
//       items: [
//         { id: 'customer', iconKey: 'users', label: 'Customer', route: 'customer', sortOrder: 1, section: 'Customer Management' },
//       ],
//     },
//     {
//       label: 'Attendance & Reports', sortOrder: 90,
//       items: [
//         { id: 'manager-attendance', iconKey: 'attendance', label: 'Manager Attendance', route: 'managerattendance', sortOrder: 1, section: 'Attendance & Reports' },
//         { id: 'supervisor-attendance', iconKey: 'attendance', label: 'Supervisor Attendance', route: 'supervisorattendance', sortOrder: 2, section: 'Attendance & Reports' },
//         { id: 'supplier-attendance', iconKey: 'attendance', label: 'Supplier Attendance', route: 'supplierattendance', sortOrder: 3, section: 'Attendance & Reports' },
//         { id: 'attendance-report', iconKey: 'report', label: 'Attendance Report', route: 'attendancereport', sortOrder: 4, section: 'Attendance & Reports', badge: '3' },
//       ],
//     },
//   ];

//   // ─── Internals ──────────────────────────────────────────────
//   private menuSubscription?: Subscription;
//   private routerSubscription?: Subscription;
//   private menuRefreshTimer?: number;

//   constructor(
//     private readonly cd: ChangeDetectorRef,
//     private readonly router: Router,
//     private readonly menuService: MenuService,
//     private readonly alertService: AlertService,
//     private readonly chrome: ChromeService,
//     private readonly coreGymService: CoreGymService,
//   ) {
//     this.navSections = this.fallbackNavSections;
//   }

//   ngOnInit(): void {

//     this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');

//     this.company = localStorage.getItem('companyName');

//     this.logo = this.currentUser.logo;

//     this.companyLogoUrl =
//       this.logo
//         ? this.coreGymService.BaseUrl + this.logo
//         : 'assets/custom/images/abg/abglogoicon512.ico';
//     this.activeRoute = this.router.url;
//     this.syncActiveFromUrl(this.router.url);
//     this.loadMenus();
//     this.startMenuRefresh();

//     this.routerSubscription = this.router.events
//       .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
//       .subscribe((e) => {
//         this.activeRoute = e.urlAfterRedirects;
//         this.syncActiveFromUrl(e.urlAfterRedirects);
//         this.cd.markForCheck();
//       });
//     this.chrome.isSidebarOpen$
//       .pipe(takeUntil(this._unsubscribeAll))   // takeUntil is already imported
//       .subscribe(open => { this.isOpen = open; });

//   }

//   ngOnDestroy(): void {
//     if (typeof window !== 'undefined' && this.menuRefreshTimer) {
//       window.clearInterval(this.menuRefreshTimer);
//     }
//     this.menuSubscription?.unsubscribe();
//     this.routerSubscription?.unsubscribe();
//   }

//   @HostListener('document:click', ['$event'])
//   onDocumentClick(event: MouseEvent): void {
//     if (!this.chrome.isSidebarOpen) { return; }
//     const target = event.target as HTMLElement;
//     // ignore clicks inside the sidebar itself and on the hamburger
//     if (target.closest('.sidebar') || target.closest('.sidebar-toggle')) { return; }
//     this.chrome.closeSidebar();
//   }

//   //@Injectable()


//   intercept(req: HttpRequest<any>, next: HttpHandler): Observable < HttpEvent < any >> {
//     // login stored it under both keys; read either.
//     const token = localStorage.getItem('accessToken') || localStorage.getItem('token');

//     // Don't attach to the auth endpoints themselves (login/refresh are anonymous).
//     const isAuthCall = req.url.includes('/auth/login') || req.url.includes('/auth/register') || req.url.includes('/auth/refresh');

//     const authReq = (token && !isAuthCall)
//       ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
//       : req;

//     return next.handle(authReq).pipe(
//       catchError((err: HttpErrorResponse) => {
//         // Token missing/expired/invalid -> session is over; send them back to login.
//         if (err.status === 401 && !isAuthCall) {
//           localStorage.removeItem('accessToken');
//           localStorage.removeItem('token');
//           this.router.navigate(['/login'], { queryParams: { returnUrl: this.router.url } });
//         }
//         return throwError(() => err);
//       })
//     );
//   }




//   // ═════════════════════════════════════════════════════════════
//   loadMenus(): void {
//     this.menuLoading = true;
//     this.menuError = false;
//     this.cd.markForCheck();
//     const currentProduct = this.safeJsonParse(localStorage.getItem('CurrentProductUId'));
//     const productUId = currentProduct?.productUId || currentProduct?.ProductUId;
//     const ugid =
//       localStorage.getItem('CurrentRoleBasedlogedin') ||
//       localStorage.getItem('roleBasedLogedin') ||
//       localStorage.getItem('currentRoleBasedLogedin') ||
//       '';
//     if (!productUId) {
//       console.warn('[verticalnav] productUId missing — using fallback menu.');
//       this.applyMenu(this.fallbackNavSections, true);
//       return;
//     }

//     this.menuSubscription?.unsubscribe();
//     this.menuSubscription = this.menuService
//       .getDashboardMenusProduct(productUId, ugid)
//       .subscribe({
//         next: (sections) => {
//           const next = sections && sections.length ? sections : this.fallbackNavSections;
//           this.applyMenu(next, false);
//         },
//         error: (err: HttpErrorResponse) => {
//           console.error('[verticalnav] menu load failed:', err);
//           this.applyMenu(this.fallbackNavSections, true);
//         },
//       });
//   }

//   refreshMenu(): void { this.loadMenus(); }

//   private applyMenu(sections: DashboardMenuSection[], errored: boolean): void {
//     this.navSections = sections;
//     this.menuLoading = false;
//     this.menuError = errored;
//     this.syncActiveFromUrl(this.activeRoute);
//     this.cd.markForCheck();
//   }

//   private startMenuRefresh(): void {
//     if (typeof window === 'undefined' || this.menuRefreshIntervalMs <= 0) return;
//     this.menuRefreshTimer = window.setInterval(() => this.loadMenus(), this.menuRefreshIntervalMs);
//   }

//   // ═════════════════════════════════════════════════════════════
//   onNavItem(item: DashboardMenuItem, event?: MouseEvent): void {
//     event?.preventDefault();
//     if (!item.route || item.route === 'null') return;

//     this.activeMenuId = item.id;
//     this.cd.markForCheck();

//     const target = this.resolveTarget(item.route);
//     this.routeChanged.emit(target);

//     this.router.navigateByUrl(target).catch((err) => {
//       console.warn(`[verticalnav] navigation to "${target}" failed:`, err);
//     });
//   }

//   private resolveTarget(route: string): string {
//     if (!route) return '';
//     if (route.startsWith('/')) return route;
//     if (!this.basePath) return '/' + route;
//     const prefix = this.basePath.startsWith('/') ? this.basePath : '/' + this.basePath;
//     return `${prefix}/${route}`.replace(/\/{2,}/g, '/');
//   }

//   private syncActiveFromUrl(url: string): void {
//     const matchAgainst = (route: string) => {
//       if (!route) return false;
//       const target = this.resolveTarget(route);
//       return url === target || url.startsWith(target + '/') || url.startsWith(target + '?');
//     };
//     const found = this.navSections
//       .flatMap((s) => s.items)
//       .find((i) => matchAgainst(i.route || ''));
//     if (found) this.activeMenuId = found.id;
//   }

//   // ═════════════════════════════════════════════════════════════
//   // Emoji icon map — covers every key produced by MenuService.toIconKey()
//   // ═════════════════════════════════════════════════════════════
//   emojiFor(iconKey: string | undefined | null): string {
//     switch ((iconKey || '').toLowerCase()) {
//       case 'dashboard': return '⊞';
//       case 'home': return '🏠';
//       case 'user': return '👤';
//       case 'users': return '🧑‍🤝‍🧑';
//       case 'eye': return '👁️';
//       case 'truck': return '🚚';
//       case 'attendance': return '🗓️';
//       case 'report': return '📋';
//       case 'order': return '🛒';
//       case 'box': return '📦';
//       case 'invoice': return '🧾';
//       case 'payment': return '💳';
//       case 'tax': return '💰';
//       default: return '📌';
//     }
//   }

//   isNavItemActive(item: DashboardMenuItem): boolean {
//     if (item.id === this.activeMenuId) return true;
//     if (!item.route) return false;
//     const target = this.resolveTarget(item.route);
//     return this.activeRoute === target || this.activeRoute.startsWith(target + '/');
//   }

//   trackByNavSection(_: number, s: DashboardMenuSection): string { return s.label; }
//   trackByNavItem(_: number, i: DashboardMenuItem): string { return i.id; }

//   private safeJsonParse(value: string | null): any {
//     if (!value) return null;
//     try { return JSON.parse(value); } catch { return null; }
//   }
// }





// import { HttpErrorResponse } from '@angular/common/http';
// import {
//   ChangeDetectionStrategy,
//   ChangeDetectorRef,
//   Component,
//   EventEmitter,
//   HostBinding,
//   Input,
//   OnDestroy,
//   OnInit,
//   Output, HostListener
// } from '@angular/core';
// import { NavigationEnd, Router } from '@angular/router';
// import { Subject, Subscription } from 'rxjs';
// import { filter, takeUntil } from 'rxjs/operators';

// import { AlertService } from '../../../_services/alert.service';
// import {
//   DashboardMenuItem,
//   DashboardMenuSection,
//   MenuService,
// } from '../../../_services/domainservice/menu.service';
// import { ChromeService } from '../../../_services/chrome.service'
// import { CoreGymService } from '../../../_services/core.gym.service.service';

// @Component({
//   selector: 'app-verticalnav',
//   templateUrl: './verticalnav.component.html',
//   styleUrls: ['./verticalnav.component.css'],
//   changeDetection: ChangeDetectionStrategy.OnPush,
// })
// export class VerticalnavComponent implements OnInit, OnDestroy {

//   @Input() isOpen = false;
//   private readonly _unsubscribeAll = new Subject<void>();

//   @Output() routeChanged = new EventEmitter<string>();

//   @Input() basePath = '';
//   @Input() menuRefreshIntervalMs = 30000;

//   @HostBinding('class.sidebar-open')
//   get hostOpen(): boolean { return this.isOpen; }

//   navSections: DashboardMenuSection[] = [];
//   menuLoading = false;
//   menuError = false;
//   activeMenuId = '';
//   activeRoute = '';
//   currentUser: any;
//   company: string;
//   companyName: string;   // used by the template alt text
//   logo: string;
//   companyLogoUrl: string;

//   readonly fallbackNavSections: DashboardMenuSection[] = [
//     {
//       label: 'Main', sortOrder: 10,
//       items: [
//         { id: 'dashboard', iconKey: 'dashboard', label: 'Dashboard', route: 'dashboard/billing', sortOrder: 1, section: 'Main' },
//       ],
//     },
//     {
//       label: 'Account & Management', sortOrder: 20,
//       items: [
//         { id: 'account-creation', iconKey: 'user', label: 'Account Creation', route: 'Billing/accountcreationforbilling', sortOrder: 1, section: 'Account & Management' },
//       ],
//     },
//     {
//       label: 'Registration', sortOrder: 30,
//       items: [
//         { id: 'manager', iconKey: 'user', label: 'Manager', route: 'manager', sortOrder: 1, section: 'Registration' },
//         { id: 'supervisor', iconKey: 'eye', label: 'Supervisor', route: 'supervisor', sortOrder: 2, section: 'Registration' },
//         { id: 'supplier', iconKey: 'truck', label: 'Supplier', route: 'supplier', sortOrder: 3, section: 'Registration' },
//       ],
//     },
//     {
//       label: 'Customer Management', sortOrder: 40,
//       items: [
//         { id: 'customer', iconKey: 'users', label: 'Customer', route: 'customer', sortOrder: 1, section: 'Customer Management' },
//       ],
//     },
//     {
//       label: 'Attendance & Reports', sortOrder: 90,
//       items: [
//         { id: 'manager-attendance', iconKey: 'attendance', label: 'Manager Attendance', route: 'managerattendance', sortOrder: 1, section: 'Attendance & Reports' },
//         { id: 'supervisor-attendance', iconKey: 'attendance', label: 'Supervisor Attendance', route: 'supervisorattendance', sortOrder: 2, section: 'Attendance & Reports' },
//         { id: 'supplier-attendance', iconKey: 'attendance', label: 'Supplier Attendance', route: 'supplierattendance', sortOrder: 3, section: 'Attendance & Reports' },
//         { id: 'attendance-report', iconKey: 'report', label: 'Attendance Report', route: 'attendancereport', sortOrder: 4, section: 'Attendance & Reports', badge: '3' },
//       ],
//     },
//   ];

//   private menuSubscription?: Subscription;
//   private routerSubscription?: Subscription;
//   private menuRefreshTimer?: number;

//   constructor(
//     private readonly cd: ChangeDetectorRef,
//     private readonly router: Router,
//     private readonly menuService: MenuService,
//     private readonly alertService: AlertService,
//     private readonly chrome: ChromeService,
//     private readonly coreGymService: CoreGymService,
//   ) {
//     this.navSections = this.fallbackNavSections;
//   }

//   ngOnInit(): void {
//     this.currentUser = this.safeJsonParse(localStorage.getItem('currentUser')) || {};

//     // *** FIX: company name — read the correct key. The old lowercase 'companyName' key holds
//     // a stale "undefined" from an earlier code path; use the user object / 'CompanyName'. ***
//     this.company =
//       this.currentUser?.companyName ||
//       localStorage.getItem('CompanyName') ||
//       'KG Technologys';
//     this.companyName = this.company;

//     this.logo = this.currentUser?.logo || localStorage.getItem('CompanyLogo') || '';
//     this.companyLogoUrl =
//       this.logo
//         ? this.coreGymService.BaseUrl + this.logo
//         : 'assets/custom/images/abg/abglogoicon512.ico';

//     this.activeRoute = this.router.url;
//     this.syncActiveFromUrl(this.router.url);
//     this.loadMenus();
//     this.startMenuRefresh();

//     this.routerSubscription = this.router.events
//       .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
//       .subscribe((e) => {
//         this.activeRoute = e.urlAfterRedirects;
//         this.syncActiveFromUrl(e.urlAfterRedirects);
//         this.cd.markForCheck();
//       });

//     this.chrome.isSidebarOpen$
//       .pipe(takeUntil(this._unsubscribeAll))
//       .subscribe(open => { this.isOpen = open; });
//   }

//   ngOnDestroy(): void {
//     if (typeof window !== 'undefined' && this.menuRefreshTimer) {
//       window.clearInterval(this.menuRefreshTimer);
//     }
//     this.menuSubscription?.unsubscribe();
//     this.routerSubscription?.unsubscribe();
//     this._unsubscribeAll.next();
//     this._unsubscribeAll.complete();
//   }

//   @HostListener('document:click', ['$event'])
//   onDocumentClick(event: MouseEvent): void {
//     if (!this.chrome.isSidebarOpen) { return; }
//     const target = event.target as HTMLElement;
//     if (target.closest('.sidebar') || target.closest('.sidebar-toggle')) { return; }
//     this.chrome.closeSidebar();
//   }

//   loadMenus(): void {
//     this.menuLoading = true;
//     this.menuError = false;
//     this.cd.markForCheck();

//     // *** THE ROOT-CAUSE FIX ***
//     // CurrentProductUId is stored as a PLAIN GUID string by login, not a JSON object.
//     // JSON.parsing it threw -> productUId was always undefined -> fell back to the static menu.
//     // Read it directly.
//     const productUId = (localStorage.getItem('CurrentProductUId') || '').trim();

//     const ugid =
//       localStorage.getItem('CurrentRoleBasedlogedin') ||
//       localStorage.getItem('roleBasedLogedin') ||
//       localStorage.getItem('currentRoleBasedLogedin') ||
//       '';

//     if (!productUId) {
//       console.warn('[verticalnav] productUId missing — using fallback menu.');
//       this.applyMenu(this.fallbackNavSections, true);
//       return;
//     }

//     console.log('[verticalnav] loading DB menu for productUId=', productUId, ' ugid=', ugid);

//     this.menuSubscription?.unsubscribe();
//     this.menuSubscription = this.menuService
//       .getDashboardMenusProduct(productUId, ugid)
//       .subscribe({
//         next: (sections) => {
//           const next = sections && sections.length ? sections : this.fallbackNavSections;
//           this.applyMenu(next, false);
//         },
//         error: (err: HttpErrorResponse) => {
//           console.error('[verticalnav] menu load failed:', err);
//           this.applyMenu(this.fallbackNavSections, true);
//         },
//       });
//   }

//   refreshMenu(): void { this.loadMenus(); }

//   private applyMenu(sections: DashboardMenuSection[], errored: boolean): void {
//     this.navSections = sections;
//     this.menuLoading = false;
//     this.menuError = errored;
//     this.syncActiveFromUrl(this.activeRoute);
//     this.cd.markForCheck();
//   }

//   private startMenuRefresh(): void {
//     if (typeof window === 'undefined' || this.menuRefreshIntervalMs <= 0) return;
//     this.menuRefreshTimer = window.setInterval(() => this.loadMenus(), this.menuRefreshIntervalMs);
//   }

//   onNavItem(item: DashboardMenuItem, event?: MouseEvent): void {
//     event?.preventDefault();
//     if (!item.route || item.route === 'null') return;

//     this.activeMenuId = item.id;
//     this.cd.markForCheck();

//     const target = this.resolveTarget(item.route);
//     this.routeChanged.emit(target);

//     this.router.navigateByUrl(target).catch((err) => {
//       console.warn(`[verticalnav] navigation to "${target}" failed:`, err);
//     });
//   }

//   private resolveTarget(route: string): string {
//     if (!route) return '';
//     if (route.startsWith('/')) return route;
//     if (!this.basePath) return '/' + route;
//     const prefix = this.basePath.startsWith('/') ? this.basePath : '/' + this.basePath;
//     return `${prefix}/${route}`.replace(/\/{2,}/g, '/');
//   }

//   private syncActiveFromUrl(url: string): void {
//     const matchAgainst = (route: string) => {
//       if (!route) return false;
//       const target = this.resolveTarget(route);
//       return url === target || url.startsWith(target + '/') || url.startsWith(target + '?');
//     };
//     const found = this.navSections
//       .flatMap((s) => s.items)
//       .find((i) => matchAgainst(i.route || ''));
//     if (found) this.activeMenuId = found.id;
//   }

//   emojiFor(iconKey: string | undefined | null): string {
//     switch ((iconKey || '').toLowerCase()) {
//       case 'dashboard': return '⊞';
//       case 'home': return '🏠';
//       case 'user': return '👤';
//       case 'users': return '🧑‍🤝‍🧑';
//       case 'eye': return '👁️';
//       case 'truck': return '🚚';
//       case 'attendance': return '🗓️';
//       case 'report': return '📋';
//       case 'order': return '🛒';
//       case 'box': return '📦';
//       case 'invoice': return '🧾';
//       case 'payment': return '💳';
//       case 'tax': return '💰';
//       default: return '📌';
//     }
//   }

//   isNavItemActive(item: DashboardMenuItem): boolean {
//     if (item.id === this.activeMenuId) return true;
//     if (!item.route) return false;
//     const target = this.resolveTarget(item.route);
//     return this.activeRoute === target || this.activeRoute.startsWith(target + '/');
//   }

//   trackByNavSection(_: number, s: DashboardMenuSection): string { return s.label; }
//   trackByNavItem(_: number, i: DashboardMenuItem): string { return i.id; }

//   private safeJsonParse(value: string | null): any {
//     if (!value) return null;
//     try { return JSON.parse(value); } catch { return null; }
//   }
// }







import { HttpErrorResponse } from '@angular/common/http';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

// Import depth normalized to 1 level up (NewLogin_RelatedFile/_services) — see the same note in
// Header.ts. Originally 3 levels up on an unevidenced guess about real-app nesting.
import { AlertService } from '../../../_services/alert.service';
import {
  DashboardMenuItem,
  DashboardMenuSection,
  MenuService,
} from '../../../_services/domainservice/menu.service';
import { ChromeService } from '../../../_services/chrome.service'



@Component({

  selector: 'app-verticalnav',
  templateUrl: './verticalnav.component.html',
  styleUrls: ['./verticalnav.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,

  // animations: [
  //   trigger('popOverState', [
  //     state('show', style({
  //       opacity: '1',
  //     })),
  //     state('hide', style({
  //       opacity: '0',
  //       height: '*',
  //     })),
  //     transition('show => hide', animate('200ms ease-in-out')),
  //     transition('hide => show', animate('200ms ease-in-out'))
  //   ])
  // ]
})
export class VerticalnavComponent implements OnInit, OnDestroy {

  @Input() isOpen = false;
  private readonly _unsubscribeAll = new Subject<void>();

  @Output() routeChanged = new EventEmitter<string>();

  @Input() basePath = '';
  @Input() menuRefreshIntervalMs = 30000;

  @HostBinding('class.sidebar-open')
  get hostOpen(): boolean { return this.isOpen; }

  navSections: DashboardMenuSection[] = [];
  menuLoading = false;
  menuError = false;
  activeMenuId = '';
  activeRoute = '';
  openSections: Record<string, boolean> = {};

  readonly fallbackNavSections: DashboardMenuSection[] = [
    {
      label: 'Main', sortOrder: 10,
      items: [
        { id: 'dashboard', iconKey: 'dashboard', label: 'Dashboard', route: 'dashboard/billing', sortOrder: 1, section: 'Main' },
      ],
    },
    {
      label: 'Account & Management', sortOrder: 20,
      items: [
        { id: 'account-creation', iconKey: 'user', label: 'Account Creation', route: 'Billing/accountcreationforbilling', sortOrder: 1, section: 'Account & Management' },
      ],
    },
    {
      label: 'Registration', sortOrder: 30,
      items: [
        { id: 'manager', iconKey: 'user', label: 'Manager', route: 'manager', sortOrder: 1, section: 'Registration' },
        { id: 'supervisor', iconKey: 'eye', label: 'Supervisor', route: 'supervisor', sortOrder: 2, section: 'Registration' },
        { id: 'supplier', iconKey: 'truck', label: 'Supplier', route: 'supplier', sortOrder: 3, section: 'Registration' },
      ],
    },
    {
      label: 'Customer Management', sortOrder: 40,
      items: [
        { id: 'customer', iconKey: 'users', label: 'Customer', route: 'customer', sortOrder: 1, section: 'Customer Management' },
      ],
    },
    {
      label: 'Attendance & Reports', sortOrder: 90,
      items: [
        { id: 'manager-attendance', iconKey: 'attendance', label: 'Manager Attendance', route: 'managerattendance', sortOrder: 1, section: 'Attendance & Reports' },
        { id: 'supervisor-attendance', iconKey: 'attendance', label: 'Supervisor Attendance', route: 'supervisorattendance', sortOrder: 2, section: 'Attendance & Reports' },
        { id: 'supplier-attendance', iconKey: 'attendance', label: 'Supplier Attendance', route: 'supplierattendance', sortOrder: 3, section: 'Attendance & Reports' },
        { id: 'attendance-report', iconKey: 'report', label: 'Attendance Report', route: 'attendancereport', sortOrder: 4, section: 'Attendance & Reports', badge: '3' },
      ],
    },
  ];

  private menuSubscription?: Subscription;
  private routerSubscription?: Subscription;
  private menuRefreshTimer?: number;

  constructor(
    private readonly cd: ChangeDetectorRef,
    private readonly router: Router,
    private readonly menuService: MenuService,
    private readonly alertService: AlertService,
    private readonly chrome: ChromeService,
  ) {
    this.navSections = this.fallbackNavSections;
  }

  ngOnInit(): void {
    this.activeRoute = this.router.url;
    this.syncActiveFromUrl(this.router.url);
    this.loadMenus();
    this.startMenuRefresh();

    this.routerSubscription = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        this.activeRoute = e.urlAfterRedirects;
        this.syncActiveFromUrl(e.urlAfterRedirects);
        this.cd.markForCheck();
      });

    this.chrome.isSidebarOpen$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(open => { this.isOpen = open; });
  }

  ngOnDestroy(): void {
    if (typeof window !== 'undefined' && this.menuRefreshTimer) {
      window.clearInterval(this.menuRefreshTimer);
    }
    this.menuSubscription?.unsubscribe();
    this.routerSubscription?.unsubscribe();
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.chrome.isSidebarOpen) { return; }
    const target = event.target as HTMLElement;
    if (target.closest('.main-menu') || target.closest('.sidebar-toggle')) { return; }
    this.chrome.closeSidebar();
  }
  private safeJsonParse(value: string | null): any {
    if (!value) return null;
    try { return JSON.parse(value); } catch { return null; }
  }
  loadMenus(): void {
    this.menuLoading = true;
    this.menuError = false;
    this.cd.markForCheck();

    // CurrentProductUId is stored as a plain GUID string by login, not a JSON object.
    const productUId = this.safeJsonParse(localStorage.getItem('currentUser')).productUId;

    const ugid =
      this.safeJsonParse(localStorage.getItem('currentUser')).userGroupUgid;

    if (!productUId) {
      console.warn('[verticalnav] productUId missing — using fallback menu.');
      this.applyMenu(this.fallbackNavSections, true);
      return;
    }

    this.menuSubscription?.unsubscribe();
    this.menuSubscription = this.menuService
      .getDashboardMenusProduct(productUId, ugid)
      .subscribe({
        next: (sections) => {
          const next = sections && sections.length ? sections : this.fallbackNavSections;
          this.applyMenu(next, false);
        },
        error: (err: HttpErrorResponse) => {
          console.error('[verticalnav] menu load failed:', err);
          this.applyMenu(this.fallbackNavSections, true);
        },
      });
  }

  refreshMenu(): void { this.loadMenus(); }

  private applyMenu(sections: DashboardMenuSection[], errored: boolean): void {
    this.navSections = sections;
    this.menuLoading = false;
    this.menuError = errored;
    this.syncActiveFromUrl(this.activeRoute);

    // Auto-expand the section containing the active route (mirrors Old's has-sub/open behavior).
    this.openSections = {};
    const activeSection = sections.find((s) => s.items.some((i) => this.isNavItemActive(i)));
    if (activeSection) { this.openSections[activeSection.label] = true; }

    this.cd.markForCheck();
  }

  private startMenuRefresh(): void {
    if (typeof window === 'undefined' || this.menuRefreshIntervalMs <= 0) return;
    this.menuRefreshTimer = window.setInterval(() => this.loadMenus(), this.menuRefreshIntervalMs);
  }

  toggleSection(section: DashboardMenuSection): void {
    this.openSections[section.label] = !this.openSections[section.label];
  }

  isSectionOpen(section: DashboardMenuSection): boolean {
    return !!this.openSections[section.label];
  }

  onNavItem(item: DashboardMenuItem, event?: MouseEvent): void {
    event?.preventDefault();
    if (!item.route || item.route === 'null') return;

    this.activeMenuId = item.id;
    this.cd.markForCheck();

    const target = this.resolveTarget(item.route);
    this.routeChanged.emit(target);

    this.router.navigateByUrl(target).catch((err) => {
      console.warn(`[verticalnav] navigation to "${target}" failed:`, err);
    });
  }

  private resolveTarget(route: string): string {
    if (!route) return '';
    if (route.startsWith('/')) return route;
    if (!this.basePath) return '/' + route;
    const prefix = this.basePath.startsWith('/') ? this.basePath : '/' + this.basePath;
    return `${prefix}/${route}`.replace(/\/{2,}/g, '/');
  }

  private syncActiveFromUrl(url: string): void {
    const matchAgainst = (route: string) => {
      if (!route) return false;
      const target = this.resolveTarget(route);
      return url === target || url.startsWith(target + '/') || url.startsWith(target + '?');
    };
    const found = this.navSections
      .flatMap((s) => s.items)
      .find((i) => matchAgainst(i.route || ''));
    if (found) this.activeMenuId = found.id;
  }

  iconClassFor(iconKey: string | undefined | null): string {
    switch ((iconKey || '').toLowerCase()) {
      case 'dashboard': return 'la-dashboard';
      case 'home': return 'la-home';
      case 'user': return 'la-user';
      case 'users': return 'la-users';
      case 'eye': return 'la-eye';
      case 'truck': return 'la-truck';
      case 'attendance': return 'la-calendar-check-o';
      case 'report': return 'la-bar-chart';
      case 'order': return 'la-shopping-cart';
      case 'box': return 'la-cube';
      case 'invoice': return 'la-file-text-o';
      case 'payment': return 'la-credit-card';
      case 'tax': return 'la-money';
      default: return 'la-circle-o';
    }
  }

  isNavItemActive(item: DashboardMenuItem): boolean {
    if (item.id === this.activeMenuId) return true;
    if (!item.route) return false;
    const target = this.resolveTarget(item.route);
    return this.activeRoute === target || this.activeRoute.startsWith(target + '/');
  }

  trackByNavSection(_: number, s: DashboardMenuSection): string { return s.label; }
  trackByNavItem(_: number, i: DashboardMenuItem): string { return i.id; }
}




